import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterType: "all",
  sortValue: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    blogFilter: (state, action) => {
      state.filterType = action.payload;
    },
    blogSort: (state, action) => {
      state.sortValue = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { blogFilter, blogSort } = filterSlice.actions;
